import { TextField, alpha, InputAdornment, useTheme } from "@mui/material"
import { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useDebounce } from "use-debounce"
import SearchIcon from '@mui/icons-material/Search'

type MenuSearchBoxProps = {
    value: string
    onChange: (value: string) => void
}

export const MenuSearchBox: React.FC<MenuSearchBoxProps> = ({
    value,
    onChange
}) => {
    const { t } = useTranslation()
    const theme = useTheme()

    const [input, setInput] = useState<string>(value)
    const [debouncedInput] = useDebounce(input, 500)

    useEffect(() => {
        setInput(value)
    }, [value])

    useEffect(() => {
        onChange(debouncedInput)
    }, [debouncedInput, onChange])

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInput(e.target.value)
    }

    return (
        <TextField
            id="menu-search-box"
            placeholder={t('cc:searchMenu')}
            variant="outlined"
            size="small"
            autoComplete="off"
            type="search"
            onChange={handleInputChange}
            value={input}
            sx={{
                '& .MuiOutlinedInput-root': {
                    borderRadius: 4,
                    backgroundColor: theme.palette.background.paper,
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.borderColors?.light ?? alpha(theme.palette.divider, 0.4),
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.light,
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.main,
                    },
                },
            }}
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                },
            }}
        />
    )
}